"use client";

import { type FC, useContext, useState } from "react";
import { AppointmentController } from "@huub-web/advisor";
import { Card, ProgressBar } from "@huub-web/ui";

import { AdvisorBookingContext } from "./AdvisorBookingContext";

/**
 * Default appointment booking widget (Calendly).
 * Reads user and URL from AdvisorBookingContext to preserve the
 * existing data flow from AppScreen → AdvisorScreen → here.
 */
export const DefaultAppointmentBooking: FC = () => {
  const context = useContext(AdvisorBookingContext);

  if (!context) {
    throw new Error(
      "DefaultAppointmentBooking must be rendered inside an AdvisorBookingContext.Provider",
    );
  }

  const { user, url } = context;
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Card
      leading={
        isLoading && <ProgressBar variant="infinite" position="absolute" />
      }
      border="default"
      padding="none"
      overflowHidden
    >
      <AppointmentController
        prefill={{
          name: user.name,
          email: user.email,
        }}
        onLoadingChange={(loading) => setIsLoading(loading)}
        url={url}
      />
    </Card>
  );
};
